import React from 'react';
import { PlayerControlsScrubberVod } from './player-controls-scrubber-vod';
import { PlayerControlsScrubberStartOver } from './player-controls-scrubber-start-over';
import { PlayerControlsScrubberLiveTv } from './player-controls-scrubber-live-tv';
import useStream from '../../_hooks/use-stream';

const componentMapper = {
  LIVE_STREAM: PlayerControlsScrubberLiveTv,
  START_OVER: PlayerControlsScrubberStartOver,
  CATCH_UP: PlayerControlsScrubberVod,
  VOD: PlayerControlsScrubberVod
};

interface Props {
  startTime?: Date;
  endTime?: Date;
}

export const PlayerControlsScrubber: React.FC<Props> = (props: Props) => {
  const { startTime, endTime } = props;

  const { streamType } = useStream();

  if (!streamType) return null;

  const Component = componentMapper[streamType] || null;

  return <Component startTime={startTime} endTime={endTime} />;
};

export default PlayerControlsScrubber;
